import { TypePolicies } from '@apollo/client';

const FeatureCacheTypePolicies: TypePolicies = {
  Query: {
    fields: {
      getFeatures: {
        keyArgs: [],
      },
    },
  },
};

export { FeatureCacheTypePolicies };
